module.exports = __webpack_public_path__ + "static/media/whatsapp.2ea59726.png";